import React, { useEffect, useState } from 'react';
import { initMetaPixel, trackViewContent } from '../utils/tracking';
import { TopBar } from './TopBar';
import { HeroSection } from './HeroSection';
import { CredibilityBar, StatsSection, PainSection, AuthorSection, RevelationSection } from './ContentSections';
import { TestimonialsSection } from './TestimonialsSection';
import { BundleSection } from './BundleSection';
import { GuaranteeSection, FaqSection, FinalCta, Footer } from './BottomSections';
const TIME_AGO_STRINGS = ['just now', '2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago', '23 minutes ago', '30 minutes ago', '45 minutes ago', '1 hour ago', '2 hours ago', '3 hours ago'];
const SOCIAL_PROOF_NAMES = [{
  name: 'Carlos M.',
  location: 'Miami, FL',
  emoji: '👨🏽'
}, {
  name: 'Sarah L.',
  location: 'Denver, CO',
  emoji: '👩'
}, {
  name: 'James T.',
  location: 'Austin, TX',
  emoji: '👨'
}, {
  name: 'Ana R.',
  location: 'Los Angeles, CA',
  emoji: '👩🏻'
}, {
  name: 'David K.',
  location: 'New York, NY',
  emoji: '👨🏾'
}, {
  name: 'Emily W.',
  location: 'Chicago, IL',
  emoji: '👩'
}, {
  name: 'Michael P.',
  location: 'San Francisco, CA',
  emoji: '👨'
}, {
  name: 'Jessica H.',
  location: 'Seattle, WA',
  emoji: '👩🏽'
}, {
  name: 'Robert N.',
  location: 'Houston, TX',
  emoji: '👨'
}, {
  name: 'Laura G.',
  location: 'Phoenix, AZ',
  emoji: '👩🏻'
}, {
  name: 'Daniel F.',
  location: 'Portland, OR',
  emoji: '👨🏽'
}, {
  name: 'Rachel B.',
  location: 'Nashville, TN',
  emoji: '👩'
}];
export function SalesPage() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [socialProof, setSocialProof] = useState<{
    name: string;
    location: string;
    emoji: string;
    timeAgo: string;
    visible: boolean;
  }>({
    ...SOCIAL_PROOF_NAMES[0],
    timeAgo: TIME_AGO_STRINGS[0],
    visible: false
  });
  // Initialize Meta Pixel & fire ViewContent
  useEffect(() => {
    initMetaPixel();
    trackViewContent();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = winScroll / height * 100;
      setScrollProgress(scrolled);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Social proof notification cycle
  useEffect(() => {
    let index = 0;
    const showNotification = () => {
      const person = SOCIAL_PROOF_NAMES[index % SOCIAL_PROOF_NAMES.length];
      const timeAgo = TIME_AGO_STRINGS[Math.floor(Math.random() * TIME_AGO_STRINGS.length)];
      setSocialProof({
        ...person,
        timeAgo,
        visible: true
      });
      // Hide after 4 seconds
      setTimeout(() => {
        setSocialProof(prev => ({
          ...prev,
          visible: false
        }));
      }, 4000);
      index++;
    };
    // First notification after 8 seconds
    const initialTimeout = setTimeout(showNotification, 8000);
    // Then every 15-25 seconds (randomized for realism)
    const interval = setInterval(() => {
      showNotification();
    }, 15000 + Math.random() * 10000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div className="min-h-screen bg-navy font-sans text-offwhite overflow-x-hidden" data-id="element-235">
      {/* Reading Progress Bar */}
      <div className="fixed left-0 top-0 z-[9999] h-[3px] bg-gradient-to-r from-neon to-neon-dark transition-all duration-100 ease-out" style={{
      width: `${scrollProgress}%`
    }} data-id="element-236" />

      <TopBar data-id="element-237" />
      <HeroSection data-id="element-238" />
      <CredibilityBar data-id="element-239" />
      <StatsSection data-id="element-240" />
      <PainSection data-id="element-241" />
      <AuthorSection data-id="element-242" />
      <RevelationSection data-id="element-243" />
      <TestimonialsSection data-id="element-244" />
      <BundleSection data-id="element-245" />
      <GuaranteeSection data-id="element-246" />
      <FaqSection data-id="element-247" />
      <FinalCta data-id="element-248" />
      <Footer data-id="element-249" />

      {/* Social Proof Notification */}
      <div className={`fixed bottom-5 left-5 z-[998] flex items-center gap-3 rounded-xl border border-neon/20 bg-slate px-4 py-3 shadow-[0_8px_30px_rgba(0,0,0,0.5)] transition-all duration-500 ${socialProof.visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-250">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-card text-xl border border-neon/20" data-id="element-251">
          {socialProof.emoji}
        </div>
        <div data-id="element-252">
          <p className="text-[13px] font-bold text-offwhite" data-id="element-253">
            {socialProof.name}{' '}
            <span className="font-normal text-coolgray" data-id="element-254">just purchased</span>
          </p>
          <p className="text-[11px] text-coolgray" data-id="element-255">
            📍 {socialProof.location} ·{' '}
            <span className="text-neon" data-id="element-256">{socialProof.timeAgo}</span>
          </p>
        </div>
        <div className="ml-1 h-2 w-2 shrink-0 animate-pulse rounded-full bg-neon" data-id="element-257" />
      </div>
    </div>;
}